export function leftPad(value: string | number, length: number, fillString = '0') {
    return String(value).padStart(length, fillString);
}
